/*!

=========================================================
* Vue Argon Dashboard - v1.1.1
=========================================================

* Product Page: https://www.creative-tim.com/product/vue-argon-dashboard
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/vue-argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import App from "./App.vue";
import router from "./router/index";
import store from "@/store";
import "./plugins";
import * as VueGoogleMaps from 'vue2-google-maps'
import 'v-markdown-editor/dist/v-markdown-editor.css';

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCeJIAFMB39HU80dKpbQowLhkHTD-uIEu0',
    libraries: 'places',
  }
});

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

// Presiona para agrandar la imagen
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});

import Editor from 'v-markdown-editor'

// global register
Vue.use(Editor);

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)

// axios
import axios from "./axios.js";

// i18n
import i18n from "./i18n";

Vue.prototype.$http = axios;
Vue.config.productionTip = false;

// custom styles
import './assets/css/styles.scss'


new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
